import BranchAdd from 'CRM/components/Add/BranchAdd'
import { Table, message } from 'antd'
import { useToken } from 'app/hooks'
import React, { useEffect, useState } from 'react'
import API from 'utils/api'
import BranchEmployeeAdd from '../../components/Add/BranchEmployeeAdd'
import BranchEmployeeEdit from '../../components/Edit/BranchEmployeeEdit'
import { TeamEdit } from "../../components/Edit/TeamEdit"
import { useTeamList } from "../../hooks/GetTeamList"
import {
	CheckboxUnit,
	DBFilterCheckboxArea,
	DBTableResultTxt
} from '../DB/styles'
import { Display } from '../Main/styles'
import { StatusWrapper } from '../Status/styles'
import { DBTableExcelBtn } from '../Customer/styles'
import TeamAdd from '../../components/Add/TeamAdd'
import {useIsMobile} from "../../components/IsMobile";

export const TeamManage = () => {
	const IsMobile = useIsMobile();
	const [scrollPosition, setScrollPosition] = useState(0);
	const { data: token } = useToken()
	const { teamList, mutate } = useTeamList()
	const [isEdit, setIsEdit] = useState(false)
	const [isAdd, setIsAdd] = useState(false)
	const [data, setData] = useState()

	const [selectUser, setSelectUser] = useState<number[]>([])
	const [isUserAdd, setIsUserAdd] = useState(false)
	const [userId, setUserId] = useState(null)

	useEffect(() => {
		if (IsMobile) {
			if (isEdit || userId !== null) {
				// 모달을 열 때 스크롤 위치 저장하고 최상단으로 이동
				setScrollPosition(window.scrollY);
				window.scrollTo({ top: 0, behavior: 'smooth' });
			} else {
				// 모달을 닫을 때 저장된 위치로 이동
				window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
			}
		}
	}, [isEdit, userId, IsMobile, scrollPosition]);


	const deleteStatus = data => {
		const shouldEdit = window.confirm(`정말 ${data?.name}을 삭제하시겠습니까?`)
		if (shouldEdit) {
			API.delete('/team?teamIds=' + data?.id, token + '', {})
				.then((res: any) => {
					if (res.result.success) {
						message.success('삭제되었습니다')
						mutate()
					}
				})
				.catch((err: any) => {})
		}
	}
	const clickDelete = () => {
		const shouldEdit = window.confirm(`선택한 직원을 삭제하시겠습니까?`)
		if (shouldEdit) {
			if (selectUser?.length == 0) {
				message.error('선택한 직원이 없습니다.')
			} else {
				API.delete('/admin?userId=' + selectUser?.join(','), token + '', {
          userId: selectUser?.join(',')
        })
					.then((res: any) => {
						if (res.result.success) {
							message.success('삭제되었습니다.')
							mutate()
						}
					})
					.catch((err: any) => {})
			}
		}
	}

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setSelectUser([...selectUser, id])
		} else {
			setSelectUser(selectUser?.filter(rowId => rowId !== id))
		}
	}

	const mobileColumns = [
		{
			dataIndex: '',
			title: '팀',
			render: (value, data) => {
				return (
					<>
						<div className="branchName" style={{ color: '#437eff', justifyContent: 'flex-start', display: 'flex' }}>
							<p style={{marginRight: 5, fontWeight: 'bold'}}>지사명: </p>
							{data?.branchName || '-'}
						</div>
						<div className="date"  style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>등록일: </p> {data?.createdAt}</div>
						<div className="branchName" style={{ color: '#437eff', justifyContent: 'flex-start', display: 'flex' }}>
							<p style={{marginRight: 5, fontWeight: 'bold'}}>팀명: </p>
							 {data?.name || '-'}
						</div>
						<div style={{ maxWidth: 400}}>
							{data?.userList?.map((it, idx) => (
								<p key={it.id} style={{ cursor: 'pointer', borderBottom: '1px solid #cdcdcd' }}>
								<span style={{ minWidth: 30, display: 'inline-block' }}>
									{/*<Checkbox*/}
									{/*	checked={selectUser?.includes(it.id)}*/}
									{/*	key={data?.id}*/}
									{/*	onChange={e => handleCheckboxChange(e, it?.id)}*/}
									{/*/>*/}
									{idx + 1}.
								</span>
									<div style={{ minWidth: 80, display: 'inline-block' }}>
										{it.leader == 1 ? '지사장' : ''} {it.teamLeader == 1 ? '팀장' : ''}
									</div>
									<span
										style={{ minWidth: 140, display: 'inline-block', color: 'blue' }}
										onClick={() => {
											setUserId(it.id)
										}}>
									{it.email}
								</span>
									<span style={{ display: 'inline-block' }}>{it.password}</span>
								</p>
							))}
						</div>
						<div className="memo" style={{justifyContent: 'flex-start', display: 'flex'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>메모: </p>{data?.desc || '-'}</div>
						<div className="btns" style={{justifyContent: 'flex-start', display: 'flex'}}>
							<button
								className="edit"
								onClick={() => {
									setIsEdit(true)
									setData(data)
								}}>
								수정
							</button>
							<button className="delete" onClick={() => deleteStatus(data)}>
								삭제
							</button>
						</div>
					</>
				)
			},
		},
	]

	const columns = [
		{
			dataIndex: '',
			title: '지사명',
			render: (value, data) => {
				return (
					<div className="branchName" style={{ color: '#437eff' }}>
						{data?.branchName}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '등록일',
			render: (value, data) => {
				return <div className="date">{data?.createdAt}</div>
			},
		},
		{
			dataIndex: '',
			title: '팀명',
			render: (value, data) => {
				return (
					<div className="branchName" style={{ color: '#437eff' }}>
						{data?.name}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '직원 목록',
			render: (value, data) => {

				return (
					<div style={{ maxWidth: 400 }}>
						{data?.userList?.map((it, idx) => (
							<p key={it.id} style={{ cursor: 'pointer', borderBottom: '1px solid #cdcdcd' }}>
								<span style={{ minWidth: 30, display: 'inline-block' }}>
									{/*<Checkbox*/}
									{/*	checked={selectUser?.includes(it.id)}*/}
									{/*	key={data?.id}*/}
									{/*	onChange={e => handleCheckboxChange(e, it?.id)}*/}
									{/*/>*/}
									{idx + 1}.
								</span>
								<div style={{ minWidth: 80, display: 'inline-block' }}>
									{it.leader == 1 ? '지사장' : ''} {it.teamLeader == 1 ? '팀장' : ''}
								</div>
								<span
									style={{ minWidth: 140, display: 'inline-block', color: 'blue' }}
									onClick={() => {
										setUserId(it.id)
									}}>
									{it.email}
								</span>
								<span style={{ display: 'inline-block' }}>{it.password}</span>
							</p>
						))}
					</div>
				)
			},
		},
		{
			dataIndex: '',
			title: '메모',
			render: (value, data) => {
				return <div className="memo">{data?.desc}</div>
			},
		},
		{
			dataIndex: '',
			title: '변경',
			render: (value, data) => {
				return (
					<div className="btns">
						<button
							className="edit"
							onClick={() => {
								setIsEdit(true)
								setData(data)
							}}>
							수정
						</button>
						<button className="delete" onClick={() => deleteStatus(data)}>
							삭제
						</button>
					</div>
				)
			},
		},
	]

	return (
		<Display IsMobile={IsMobile}>
			<StatusWrapper>
				<DBFilterCheckboxArea IsMobile={IsMobile}>
					<CheckboxUnit>
						<DBTableResultTxt style={{marginLeft: 0}} IsMobile={IsMobile}>
							조회결과: 총 <span>{teamList?.length}</span> 개
						</DBTableResultTxt>
					</CheckboxUnit>
					{/*<div style={{ display: 'flex', gap: 10 }}>*/}
						<DBTableExcelBtn
							onClick={() => setIsAdd(true)}
							style={{ backgroundColor: '#437eff', color: '#fff' }}>
							팀등록
						</DBTableExcelBtn>

				</DBFilterCheckboxArea>
				<Table className="DBTable" dataSource={teamList} columns={ IsMobile ? mobileColumns : columns} bordered={true} />

				{isEdit && <TeamEdit setIsEdit={setIsEdit} data={data} mutate={mutate} />}
				{isAdd && <TeamAdd setIsAdd={setIsAdd} />}

				{isUserAdd && <BranchEmployeeAdd setIsAdd={setIsUserAdd} mutate={mutate} />}
				{userId !== null && (
					<BranchEmployeeEdit userId={userId} setUserId={setUserId} mutate={mutate} />
				)}
			</StatusWrapper>
		</Display>
	)
}

export default React.memo(TeamManage)
